module.exports = __webpack_public_path__ + "img/hibob.e8146cdc.svg";